import React, { useReducer, useEffect } from 'react'
import { publicProfileInitialState } from './store/State'
import publicProfileReducer from './store/Reducer'
import PublicProfileService from './Service'
import { IPublicProfileProps } from './Interfaces'

const publicProfileContext = {
  state: publicProfileInitialState,
  handlers: {
    getUserData: () => {}
  }
}

export type PublicProfileContext = typeof publicProfileContext

export const PublicProfileContextProvider = React.createContext<PublicProfileContext>(publicProfileContext)

const Provider: React.FC<IPublicProfileProps> = ({ children, userId, enterpriseId }) => {
  const [state, dispatch] = useReducer(publicProfileReducer, publicProfileInitialState)

  const handlers = {
    getUserData: PublicProfileService.onMount(userId, enterpriseId, dispatch)
  }

  useEffect(() => {
    handlers.getUserData()
  }, [])

  const contextValue = {
    ...publicProfileContext,
    state,
    handlers
  }

  return <PublicProfileContextProvider.Provider value={contextValue}>{children}</PublicProfileContextProvider.Provider>
}

export default Provider
